// Eudonet preset filter catalog for the subscriptions page (OP-6176).
// Each preset is a single filter criterion shown as a checkbox in the "Eudonet"
// group of the "Mes listes" dropdown. The user checks one or more and clicks
// "Créer la liste" to create a custom list whose filter is their combination.
// Mirrors donationViewPresets.ts — only the filterable dimensions differ
// (subscriptions filter server-side on status + frequency).
export const SUBSCRIPTION_VIEW_PRESETS = [
    { id: "active", labelKey: "finance.subscriptions.status.Active", filterKey: "status", value: "Active" },
    { id: "paused", labelKey: "finance.subscriptions.status.Paused", filterKey: "status", value: "Paused" },
    { id: "cancelled", labelKey: "finance.subscriptions.status.Canceled", filterKey: "status", value: "Canceled" },
    { id: "expired", labelKey: "finance.subscriptions.status.Expired", filterKey: "status", value: "Expired" },
    { id: "monthly", labelKey: "finance.subscriptions.frequency.Monthly", filterKey: "frequency", value: "Monthly" },
    {
        id: "quarterly",
        labelKey: "finance.subscriptions.frequency.Quarterly",
        filterKey: "frequency",
        value: "Quarterly",
    },
    { id: "yearly", labelKey: "finance.subscriptions.frequency.Yearly", filterKey: "frequency", value: "Yearly" },
];
/**
 * Maps a table filter key to the i18n sub-namespace under `finance.subscriptions`, so any filter
 * value can be labelled via `finance.subscriptions.{group}.{value}`.
 */
export const FILTER_KEY_I18N_GROUP = {
    status: "status",
    frequency: "frequency",
};
const PRESET_BY_ID = new Map(SUBSCRIPTION_VIEW_PRESETS.map((p) => [p.id, p]));
/** Returns the i18n label key for a preset id, or undefined if the id is unknown/stale. */
export function presetLabelKey(id) {
    return PRESET_BY_ID.get(id)?.labelKey;
}
const PRESET_BY_FILTER_VALUE = new Map(SUBSCRIPTION_VIEW_PRESETS.map((p) => [`${p.filterKey}:${p.value}`, p]));
/**
 * i18n label key for a (filterKey, value) pair. Reuses the Eudonet preset's label when one
 * matches; values outside the preset catalog fall back to the value-derived
 * `finance.subscriptions.{group}.{value}` key.
 */
export function filterValueLabelKey(filterKey, value) {
    const preset = PRESET_BY_FILTER_VALUE.get(`${filterKey}:${value}`);
    if (preset)
        return preset.labelKey;
    const group = FILTER_KEY_I18N_GROUP[filterKey] ?? filterKey;
    return `finance.subscriptions.${group}.${value}`;
}
/**
 * Builds a table query snapshot from a set of preset ids, grouping by filter key
 * (so two statuses become `status in [a, b]`, while a status + a frequency AND together).
 * Unknown ids are ignored.
 */
export function buildPresetQuerySnapshot(presetIds) {
    const filters = {};
    for (const id of presetIds) {
        const preset = PRESET_BY_ID.get(id);
        if (!preset)
            continue;
        const existing = filters[preset.filterKey];
        if (existing) {
            if (!existing.values.includes(preset.value))
                existing.values.push(preset.value);
        }
        else {
            filters[preset.filterKey] = { type: "in", values: [preset.value] };
        }
    }
    return { filters };
}
